<template>
  <div class="identity-page">
    <div class="phone">
      <header class="topbar">
        <div class="topbar-left">
          <button class="icon-btn" type="button" aria-label="返回" @click="goBack">
            <i class="el-icon-arrow-left"></i>
          </button>
        </div>
        <h1 class="title">身份信息</h1>
        <div class="topbar-right">
          <button class="icon-btn ghost" type="button" aria-label="收藏">
            <i class="el-icon-star-off"></i>
          </button>
          <button class="icon-btn ghost" type="button" aria-label="更多">
            <i class="el-icon-more"></i>
          </button>
          <button class="icon-btn ghost" type="button" aria-label="回到首页" @click="goHome">
            <span class="exit-ring" aria-hidden="true"></span>
          </button>
        </div>
      </header>

      <div class="content">
        <section class="card">
          <div class="row">
            <span class="label">实名认证状态</span>
            <span class="value status">{{ realNameStatus }}</span>
          </div>
          <div class="row clickable">
            <span class="label">身份基本信息</span>
            <span class="value with-arrow">已完善<i class="el-icon-arrow-right chev"></i></span>
          </div>
          <div class="row clickable">
            <span class="label">身份证照片</span>
            <span class="value with-arrow">已上传<i class="el-icon-arrow-right chev"></i></span>
          </div>
          <div class="row row-last">
            <span class="label">人脸验证</span>
            <span class="value">已验证</span>
          </div>
        </section>

        <section class="card card-action">
          <button class="row-btn" type="button" @click="goIdCard">
            <span class="label">更新姓名或证件号码</span>
            <i class="el-icon-arrow-right chev"></i>
          </button>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AlipayIdentityInfoPage",
  data() {
    return {
      realNameStatus: "**琪(已认证)",
    };
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    goHome() {
      this.$router.push({ name: "AlipayFlowHome" });
    },
    goIdCard() {
      this.$router.push("/IdCard");
    },
  },
};
</script>

<style scoped>
.identity-page {
  min-height: 100vh;
  background: #f7f7f7;
  display: flex;
  justify-content: center;
  -webkit-font-smoothing: antialiased;
}

.phone {
  width: 100%;
  max-width: 430px;
  min-height: 100vh;
  background: #f7f7f7;
  text-align: left;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
}

.topbar {
  display: grid;
  grid-template-columns: 88px 1fr 88px;
  align-items: center;
  height: 50px;
  padding: 0 6px 0 2px;
  background: #fff;
  box-sizing: border-box;
}

.topbar-left {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.title {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  color: #000;
  text-align: center;
  letter-spacing: 0.2px;
}

.topbar-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 2px;
}

.icon-btn {
  border: none;
  background: transparent;
  padding: 8px;
  cursor: pointer;
  color: #1f1f1f;
  font-size: 22px;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.icon-btn.ghost {
  color: #2c2c2c;
}

.icon-btn:active {
  opacity: 0.45;
}

/* 小程序风格：外圈 + 内圈 */
.exit-ring {
  display: block;
  width: 20px;
  height: 20px;
  border: 1.5px solid #2c2c2c;
  border-radius: 50%;
  box-sizing: border-box;
  position: relative;
}

.exit-ring::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  width: 7px;
  height: 7px;
  margin: -3.5px 0 0 -3.5px;
  border: 1.5px solid #2c2c2c;
  border-radius: 50%;
  box-sizing: border-box;
}

.content {
  padding: 10px 12px 28px;
}

.card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 10px;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);
}

.card .row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  min-height: 52px;
  box-sizing: border-box;
  border-bottom: 1px solid #ebebeb;
}

.card .row-last {
  border-bottom: none;
}

.label {
  font-size: 16px;
  font-weight: 400;
  color: #000;
  flex-shrink: 0;
}

.value {
  font-size: 15px;
  font-weight: 400;
  color: #999;
  text-align: right;
  margin-left: 12px;
  flex: 1;
  min-width: 0;
}

.value.status {
  color: #b2b2b2;
  letter-spacing: 0.02em;
}

.value.with-arrow {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 2px;
  color: #b2b2b2;
}

.chev {
  font-size: 13px;
  color: #c6c6c6;
  margin-left: 2px;
  font-weight: 600;
}

.row.clickable:active {
  background: #fafafa;
}

.card-action {
  margin-bottom: 0;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);
}

.row-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  min-height: 52px;
  border: none;
  background: #fff;
  cursor: pointer;
  text-align: left;
}

.row-btn .label {
  font-size: 16px;
  color: #000;
}

.row-btn:active {
  background: #fafafa;
}

.row-btn .chev {
  flex-shrink: 0;
}
</style>
